import React, {useState} from "react";
import ProfileHeader from "../Headers/ProfileHeader";
import LinkDevice from "./LinkDevice";
import {Redirect} from "react-router-dom";
import ProfileComplete from "./ProfileComplete";

function LinkDeviceWrapper(props: { cognitoUser: any, loadData: () => Promise<void>}) {
  const {cognitoUser, loadData} = props;
  const [isLinked, setIsLinked] = useState(false);
  const [step, setStep] = useState(2)
  const maxSteps = 3;

  console.log('step', step)

  function nextFn(): void {
    if (step < maxSteps) {
      setStep(step + 1)
    }
  }

  function complete() {
    loadData().then(() => {
      setIsLinked(true);
      }
    );
  }

  if (isLinked) {
    console.log('redirecting to home')
    return <Redirect to="/home"/>
  }

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title="Link Device" linkToHome="/home"/>
      <LinkDevice step={step} nextFn={nextFn}/>
      <ProfileComplete step={step} getRealvrUser={complete}/>
    </>
  );
}

export default LinkDeviceWrapper;
